var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.tag,{tag:"component",staticClass:"text-secondary",class:{
    'leading-none font-normal text-sm underline': _vm.href,
    'leading-short font-medium no-underline flex items-center justify-center': _vm.to,
  },attrs:{"href":_vm.href,"target":_vm.computedTarget,"to":_vm.to},on:{"click":_vm.handleClick}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }